import { render, staticRenderFns } from "./MealsShiftsChart.vue?vue&type=template&id=ef46ec22"
import script from "./MealsShiftsChart.vue?vue&type=script&lang=js"
export * from "./MealsShiftsChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports